module.exports = {"svg":{"$":{"width":"10","height":"6","viewBox":"0 0 10 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"path":[{"$":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.8 6L0 0L9.6 0L4.8 6Z","fill":"white"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/assets/svg/foreign-change.svg
// module id = kpDc
// module chunks = 2